import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:5000/api"
    : "https://api.emamigold.com/api");

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Request interceptor - جلوگیری از ارسال request اگه rate limited هستیم
api.interceptors.request.use(
  (config) => {
    const isRateLimited = localStorage.getItem("rateLimitActive") === "true";
    const startTime = localStorage.getItem("rateLimitStartTime");
    
    if (isRateLimited && startTime) {
      const elapsed = Math.floor((Date.now() - parseInt(startTime)) / 1000);
      const RATE_LIMIT_DURATION = 15 * 60; // 15 دقیقه
      
      // اگه زمان گذشته، flag ها رو پاک کن و بذار request بره
      if (elapsed >= RATE_LIMIT_DURATION) {
        localStorage.removeItem("rateLimitActive");
        localStorage.removeItem("rateLimitStartTime");
        return config;
      }
      
      // اگه هنوز rate limited هستیم، request رو کنسل کن
      const error = new Error("Rate limit active");
      error.isRateLimitActive = true;
      return Promise.reject(error);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - مدیریت rate limit از سمت سرور
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // اگه خطا به خاطر rate limit active باشه، redirect نکن
    if (error.isRateLimitActive) {
      return Promise.reject(error);
    }
    
    // اگه سرور rate limit برگردوند
    if (
      error.response?.status === 429 &&
      error.response?.data?.rateLimitExceeded
    ) {
      // ذخیره زمان شروع محدودیت (اگه قبلاً ذخیره نشده)
      if (!localStorage.getItem("rateLimitStartTime")) {
        localStorage.setItem("rateLimitStartTime", Date.now().toString());
      }
      
      // ست کردن flag برای جلوگیری از request های بعدی
      localStorage.setItem("rateLimitActive", "true");
      
      // جلوگیری از redirect loop - فقط اگه الان توی صفحه rate-limit نیستیم
      if (!window.location.pathname.includes("/rate-limit")) {
        // با setTimeout جلوی race condition رو میگیریم
        setTimeout(() => {
          window.location.href = "/rate-limit";
        }, 100);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
